import { api, DashboardResponse, GetDashboardParams } from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';

const dashboardApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboard: builder.query<DashboardResponse, GetDashboardParams>({
      query: (params) => api.dashboard.getDashboard(params),
    }),
  }),
});

export const { useGetDashboardQuery } = dashboardApi;
